module.exports = __webpack_public_path__ + "static/media/10-04.94473d19.png";